import { isSSR } from "./isSSR";
export var isIE11 = function isIE11() {
  if (isSSR()) return false;

  // true on IE11
  // false on Edge and other IEs/browsers.

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return !!window.MSInputMethodContext && !!document.documentMode;
};